import StoredLayout from '../../layouts/StoredLayout'
import Typography from './Typography'
export default StoredLayout(Typography)



// WEBPACK FOOTER //
// ./src/ui-elements/typography/index.js